import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { WebhookLogReplayDto } from "@/api/dtos";
import type { WebhookLogReplay } from "./_models/WebhookLog";
import { toWebhookLogReplayFromWebhookLogReplayDto } from "./_transformers/toWebhookLogReplayFromWebhookLogReplayDto";
import { WebhookLogTags } from "./WebhookLogTags";

/** Replays a logged webhook (POST /webhook-logs/{id}/replays): its handler runs again against the backend's Cin7 account and database, recorded as a new row. WRITE. */
export const replayWebhookLogApi = api.injectEndpoints({
  endpoints: (builder) => ({
    replayWebhookLog: builder.mutation<WebhookLogReplay, string>({
      queryFn: async (webhookLogId) => {
        try {
          const res = await axios.post<WebhookLogReplayDto>(
            `${backendBase()}/webhook-logs/${encodeURIComponent(webhookLogId)}/replays`,
            undefined,
            { headers: { Accept: "application/json" } },
          );
          const replay = toWebhookLogReplayFromWebhookLogReplayDto(res.data);
          return { data: replay };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      invalidatesTags: [{ type: WebhookLogTags.WebhookLog, id: "LIST" }],
    }),
  }),
});

export const replayWebhookLog = replayWebhookLogApi.endpoints.replayWebhookLog;
